<template>
  <div class="nav-container">
    <div class="main-menu">
      <b-nav
        vertical
        class="menu"
      >
        <div
          v-for="section in sections"
          v-if="section.visible"
          :key="section.id"
        >
          <b-nav-item
            :to="hasSubSections(section) ? null : getRouteTo(section)"
            :title="section.name"
            active-class="active"
            exact
            @click="toggleCollapse(section)"
          >
            <div class="menu-row">
              <span class="menu-icon">
                <i :class="section.icon" />
              </span>
              <span class="text-menu">{{ section.name | capitalize }}</span>

              <i
                v-if="hasSubSections(section)"
                class="fas fa-caret-down caret-down"
              />
            </div>
          </b-nav-item>
          <b-collapse
            v-if="hasSubSections(section)"
            :id="section.id"
          >
            <b-nav-item
              v-for="subSection in section.subSections"
              :key="subSection.id"
              :to="getRouteTo(subSection)"
              :title="subSection.name"
              active-class="active"
              exact
            >
              <div class="menu-row">
                <span class="text-menu text-submenu">{{ subSection.name | capitalize }}</span>
              </div>
            </b-nav-item>
          </b-collapse>
        </div>
      </b-nav>

      <div class="nav-bottom-logo">
        <div class="text-center">
          <a
            href="https://www.bmat.com"
            target="_blank"
          >
            powered by
            <img
              class="bmat-logo"
              src="../../assets/img/logo_grey.svg"
              alt="BMAT"
            >
          </a>
          <p class="text-muted" v-if="version">v{{ version }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { has } from "lodash"
import { mapGetters } from "vuex"

export default {
  name: "Navbar",
  data: function () {
    return {
      version: this.$config.VERSION
    }
  },
  computed: {
    ...mapGetters("soundsys", ["isMlc", "isSisterSociety"]),
    sections () {
      return [
        {
          name: this.$t("repertoire"),
          id: "repertoire",
          icon: "far fa-music",
          visible: true,
          subSections: [
            {
              name: this.$t("uploads"),
              id: "repertoire-files",
            },
            {
              name: this.$t("soundSysDatabase"),
              id: "sound-recordings",
            },
            {
              name: this.$t("claimWorkspace"),
              id: "claims",
            },
          ]
        },
        {
          name: this.$t("playlists"),
          id: "playlists",
          icon: "far fa-file-alt",
          visible: this.isMlc && !this.isSisterSociety,
          subSections: [
            {
              name: this.$t("uploads"),
              id: "playlist-files",
            },
            {
              name: this.$t("usages"),
              id: "usages",
            },
          ]
        },
        {
          name: this.$t("funds"),
          id: "funds",
          icon: "far fa-usd-circle",
          visible: this.isMlc && !this.isSisterSociety,
        },
        {
          name: this.$t("distributions"),
          id: "distributions",
          icon: "far fa-file-invoice-dollar",
          visible: this.isMlc && !this.isSisterSociety,
        },
        {
          name: this.$t("distributions"),
          id: "distributions-members",
          icon: "far fa-file-invoice-dollar",
          visible: !this.isMlc || (this.isMlc && this.isSisterSociety),
        },
        {
          name: this.$t("members"),
          id: "members-list",
          icon: "far fa-user-circle",
          visible: this.isMlc && !this.isSisterSociety,
        },
        {
          name: this.$t("people"),
          id: "users-list",
          icon: "far fa-user-circle",
          visible: !this.isMlc || (this.isMlc && this.isSisterSociety),
        }
      ]
    },
  },
  methods: {
    hasSubSections (section) {
      return has(section, "subSections")
    },
    toggleCollapse (section) {
      if (this.hasSubSections(section)) this.$root.$emit("bv::toggle::collapse", section.id)
    },
    getRouteTo (section) {
      if (this.$route.name === section.id) return { ...this.$route }
      return {
        name: section.id,
        query: section.query
      }
    }
  }
}
</script>
